/**
 * Compat re-exports for App-hidden platform fields.
 * Prefer importing from `platformInternalAttrs` in new code.
 */
import {
  PLATFORM_INTERNAL_ATTR_NAMES,
  boundAttrName,
  isPlatformInternalAttr,
  isAppHiddenAttr,
} from './platformInternalAttrs'

export {
  PLATFORM_INTERNAL_ATTR_NAMES,
  boundAttrName,
  isPlatformInternalAttr,
  isAppHiddenAttr,
}

/**
 * True when a row is a predefined (Designer-seeded) record: `is_system` truthy
 * in any of its serialized forms, or a non-empty `predefined_name`.
 */
export function isPredefinedRecord(row: Record<string, unknown> | null | undefined): boolean {
  if (!row) return false
  const sys = row.is_system
  if (sys === true || sys === 1 || sys === 'true' || sys === '1') return true
  return String(row.predefined_name ?? '').trim() !== ''
}
